import Feature from 'Services/Feature';
import OnboardingController from 'vcomponents/pa/mandate/Onboarding/OnboardingController.vue';

const checkAccess = (to, from, next) => {
    if (!Feature.isEnabled('einvoicing-pdp-mandates')) {
        return next({ name: 'error.not.found' });
    }
    next();
};

export default [
    {
        path: '/pa/mandate/onboarding',
        name: 'pa.mandate.onboarding',
        component: OnboardingController,
        beforeEnter: checkAccess,
    },
];
